import src from '../assets/tapandtees.png';
import { imageLogo } from './imageLogo';

/**
 * Tap & Tees — full-color square badge (opaque white ground, as delivered).
 * Was a 692KB base64 data URI inlined in the module; now a 69KB quantized
 * first-party asset.
 */
export const TapAndTeesLogo = imageLogo({
  src,
  width: 1000,
  height: 1000,
  alt: 'Tap & Tees',
});
